
export class Sostenedor {
    public ARut: string;
    public Aserialrut: string;
    public ANombre: string;
    public AApellido: string;
    public AFechaN: string;
    public ATelefono: string;
    public ACorreo: string;
    public IdProceso?: string;
  constructor(data: any) {
        this.ARut = data.ARut;
        this.Aserialrut = data.Aserialrut;
        this.ANombre = data.ANombre;
        this.AApellido = data.AApellido;
        this.AFechaN = data.AFechaN;
        this.ATelefono = data.ATelefono;
        this.ACorreo = data.ACorreo;
        this.IdProceso = data.IdProceso;
  }
}
